import { filter } from "lodash"
import { Link } from "react-router-dom"
import { Button, ReportButton } from "../../../components/Button"
import { MarkText } from "../../../components/MarkText"
import { CircleIcon } from "../../../icons/CircleIcon"
import { UntestedIcon } from "../../../icons/UntestedIcon"
import { UsersIcon } from "../../../icons/UsersIcon"
import { VerifiedIcon } from "../../../icons/VerifiedIcon"
import { GRANTS, YESNO } from "../../../settings"
import { getTitle, highlightText } from "../../../utils"

export const users = ({ isAdmin, orgRead, userWrite, pathname, search, org, showForm, editValues, context, orgName, orgAlias }) => ({
    enabled: isAdmin || orgAlias == org && orgRead,
    header: isAdmin && !org && <ReportButton makeReport={() => showForm("users_report")}/>,
    footer: <>
            {userWrite &&
            <Button onClick={() => showForm("users")}>
                <UsersIcon size={20} />
                Add User
            </Button>}
            {!isAdmin && userWrite &&
            <Button onClick={() => editValues({ entity: "grants", values: { orgAlias: org } })}>
                <UsersIcon size={20} />
                Issue Grant
            </Button>}
            </>,
    columns: [
        {
            title: <CircleIcon size={16} />,
            dataIndex: 'disabled',
            render: (text, record, index) =>
                <>
                    {text ? <UntestedIcon size={16} /> : <VerifiedIcon size={16} /> }
                </>,
            width: 56,
            sorter: (a, b) => { if (a && a.hasOwnProperty("disabled")) return (a.disabled === b.disabled )? 0 : a.disabled ? 1 : -1 }
        },
        {
            title: "User Name",
            dataIndex: "fullName",
            defaultSortOrder: "asc",
            render: (text, record, index) => (
                <Link to={{ pathname: `${pathname}/${record.key}`, state: { from: pathname + search }}}>
                    <MarkText title={text} text={highlightText(text, context)} />
                </Link>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("fullName") && a.fullName) return a.fullName.localeCompare(b.fullName) }
        },
        {
            title: "E-Mail",
            dataIndex: "email",
            render: (text, record, index) => (
                <a href={`mailto: ${text}`}>
                    <MarkText title={text} text={highlightText(text, context)} />
                </a>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("email") && a.email) return a.email.localeCompare(b.email) }
        },
        {
            title: "Default Organization",
            dataIndex: "defaultOrgName",
            render: (text, record, index) => (
                isAdmin
                    ? <Link to={`/organisations/${record.orgAlias}`}>
                        <MarkText title={text} text={highlightText(text, context)} />
                    </Link>
                    : <MarkText title={text} text={highlightText(text, context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("defaultOrgName") && a.defaultOrgName) return a.defaultOrgName.localeCompare(b.defaultOrgName) }
        },
        {
            title: "Grant Name",
            dataIndex: "grantName",
            width: 150,
            render: (text, record, index) => (
                <MarkText title={text} text={highlightText(getTitle(text, GRANTS), context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("grantName") && a.grantName) return a.grantName.localeCompare(b.grantName) }
        },
        {
            title: "Expired",
            dataIndex: "expiryDate",
            width: 100,
            sorter: (a, b) => { if (a && a.hasOwnProperty("expiryDate") && a.expiryDate) return a.expiryDate.localeCompare(b.expiryDate) }
        }
    ],
    searchOptions: [
        { key: "grant", title: "Grant", type: "select", options: isAdmin ? GRANTS : filter(GRANTS, { visible: true }), placeholder: "The name of the user grant.", multiple: true },
        { key: "disabled", title: "Disabled", type: "boolean", options: YESNO, placeholder: "User's account status (enabled/disabled)." },
        { key: "grant_expired", title: "Grant expired", type: "boolean", options: YESNO, placeholder: "User's grant expiration status (active/expired)." }
    ],
    breadcrumbs: org
        ? [
            { title: orgName, href: "/organisations/" + org },
            { title: "Users" }
        ]
        : null
});